const grid = {
	mobile: {
		columns: 6,
		gutter: 8,
		margin: 8,
		mockupWidth: 375,
	},
	tablet: {
		columns: 12,
		gutter: 8,
		margin: 8,
		mockupWidth: 768,
	},
	desktop: {
		columns: 12,
		gutter: 8,
		margin: 8,
		mockupWidth: 1440,
	},
};

export function calculateWidth(columns, gutter, margin, mockupWidth, span = 1) {
	const gutterTotal = (columns - 1) * gutter;
	const width = mockupWidth - margin * 2 - gutterTotal;
	const columnWidth = width / columns;

	return (span - 1) * (columnWidth + gutter) + columnWidth;
}

export function pxToVw(px, mockupWidth) {
	return `${(px / mockupWidth) * 100}vw`;
}

export function calculateGap(gutter, mockupWidth) {
	return pxToVw(gutter, mockupWidth);
}

export function calculateMargin(margin, mockupWidth) {
	return pxToVw(margin, mockupWidth);
}

export default grid;
